export const iconFontAwesomeUsersPeopleImagePortrait = (
	<i className="fa-solid fa-image-portrait"></i>
);
